module.exports = __webpack_public_path__ + "assets/img/icon_congrats.3cda02f2.png";